import React, { useState } from 'react';
import { Dropdown, Button, Tag, Space, Popconfirm } from 'antd';
import { DownOutlined, EyeOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';

const IndividualItemsDropdown = ({ 
  baseId, 
  quantity, 
  itemName,
  onViewItem,
  onDeleteItem,
  onDownloadQR,
  showActions = true 
}) => {
  const [open, setOpen] = useState(false);

  const generateIndividualItems = () => {
    const items = [];
    for (let i = 1; i <= quantity; i++) {
      items.push({
        key: `${baseId}${i}`,
        label: (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            minWidth: '200px'
          }}>
            <Tag color="blue">{`${baseId}${i}`}</Tag>
            {showActions && (
              <Space size="small">
                <Button 
                  type="text" 
                  size="small" 
                  icon={<EyeOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onViewItem?.(`${baseId}${i}`);
                    setOpen(false);
                  }}
                  title="View Item"
                />
                <Button 
                  type="text" 
                  size="small" 
                  icon={<DownloadOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDownloadQR?.(`${baseId}${i}`, itemName);
                    setOpen(false);
                  }}
                  title="Download QR"
                />
                <Popconfirm
                  title="Remove Item"
                  description={`Remove ${baseId}${i} permanently?`}
                  onConfirm={(e) => {
                    e?.stopPropagation();
                    onDeleteItem?.(`${baseId}${i}`);
                    setOpen(false);
                  }}
                  okText="Remove"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Button 
                    type="text" 
                    size="small" 
                    icon={<DeleteOutlined />}
                    danger
                    onClick={(e) => e.stopPropagation()}
                    title="Remove Item"
                  />
                </Popconfirm>
              </Space>
            )}
          </div>
        ),
      });
    }
    return items;
  };

  const menu = {
    items: generateIndividualItems(),
  };

  if (quantity === 0) {
    return <Tag color="red">No items</Tag>;
  }

  return (
    <Dropdown
      menu={menu}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      placement="bottomLeft"
    >
      <Button size="small" onClick={(e) => e.preventDefault()}>
          {quantity} items
          <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default IndividualItemsDropdown;
